import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtAnalyticsModule } from '@recruitee/analytics';

import { AvatarModule } from '../avatar/avatar.module';
import { GroupModule } from '../group/group.module';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { CandidatesAvatarsComponent } from './candidates-avatars.component';

@NgModule({
  imports: [AvatarModule, CommonModule, GroupModule, IconModule, RtAnalyticsModule, TooltipModule],
  declarations: [CandidatesAvatarsComponent],
  exports: [CandidatesAvatarsComponent],
})
export class CandidatesAvatarsModule {}

export { CandidatesAvatarsComponent } from './candidates-avatars.component';
